import { useMount } from 'react-use';

import { getLocalSettings } from 'components/settings/api/personal';
import { useServerStorage } from 'utils/useServerStorage';

/**
 * Migrates conversation sidebar settings from localStorage to user-storage.
 * Covers: `conversationCards`, `isCustomCardMenuOpen`, `elevioCardOpen`, and
 * `knowledgeCardOpen`. Runs once on mount. Skips if user-storage already has
 * sidebar data.
 *
 * TODO: Remove this migration after rollout is complete.
 */
export const useConversationSidebarSettingsMigration = (): void => {
  const storage = useServerStorage('user');

  useMount(() => {
    if (
      storage.data.conversation?.sidebarCardOpenState !== undefined ||
      storage.data.conversation?.isSidebarOpen !== undefined
    ) {
      return;
    }

    const localSettings = getLocalSettings();
    if (!localSettings) return;

    const hasSettingsToMigrate =
      !!localSettings.conversationCards ||
      localSettings.isCustomCardMenuOpen != null ||
      localSettings.elevioCardOpen != null ||
      localSettings.knowledgeCardOpen != null;

    if (!hasSettingsToMigrate) return;

    storage.set({
      conversation: (draft) => {
        if (localSettings.conversationCards) {
          draft.sidebarCardOpenState = localSettings.conversationCards;
        }
        if (localSettings.elevioCardOpen != null) {
          draft.sidebarCardOpenState = {
            ...draft.sidebarCardOpenState,
            elevio: localSettings.elevioCardOpen,
          };
        }
        if (localSettings.knowledgeCardOpen != null) {
          draft.sidebarCardOpenState = {
            ...draft.sidebarCardOpenState,
            knowledge: localSettings.knowledgeCardOpen,
          };
        }
        if (localSettings.isCustomCardMenuOpen != null) {
          draft.isSidebarOpen = localSettings.isCustomCardMenuOpen;
        }
      },
    });
  });
};
